(function($) {

	$.fn.selectActionForm = function() {

		return this.each(function() {
			var $this = $(this);
            $this.on('change', 'select', function(){
                window.location.href = $(this).find(':selected').data('action');
            });
        });
	};

})(jQuery);